import { render, staticRenderFns } from "./OverviewFuelKso.vue?vue&type=template&id=90ebee0e"
import script from "./OverviewFuelKso.vue?vue&type=script&lang=js"
export * from "./OverviewFuelKso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports